export default __webpack_public_path__ + "static/media/meatchops.3b3ee33f.png";